export type GenericMouseEvent = {
  defaultPrevented: boolean
  preventDefault: () => void
  view: unknown
}
